import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [CommonModule]
})
export class HomeComponent {

  perguntaAberta: number | null = null;

  perguntas = [
    {
      pergunta: 'O que é o CuidaZap?',
      resposta: 'O CuidaZap é uma solução que auxilia no acompanhamento e na organização da rotina de cuidados.'
    },
    {
      pergunta: 'Minhas conversas ficam salvas?',
      resposta: 'Sim. As conversas são armazenadas de forma segura para permitir o acompanhamento do usuário.'
    },
    {
      pergunta: 'Em quais horários o CuidaZap funciona?',
      resposta: 'O CuidaZap está disponível para auxiliar você na sua rotina de cuidados.'
    },
    {
      pergunta: 'Consigo usar o CuidaZap em mais de um número de WhatsApp?',
      resposta: 'Sim. O CuidaZap pode ser utilizado de acordo com a configuração do seu plano.'
    },
    {
      pergunta: 'Como funciona o cancelamento dos Planos?',
      resposta: 'O cancelamento pode ser solicitado conforme as condições previstas no seu plano.'
    },
    {
      pergunta: 'O CuidaZap substitui médicos ou outros profissionais de saúde?',
      resposta: 'Não. O CuidaZap é uma ferramenta de apoio e não substitui médicos ou outros profissionais de saúde.'
    },
    {
      pergunta: 'O CuidaZap pode indicar ou prescrever medicamentos?',
      resposta: 'Não. O CuidaZap não prescreve nem recomenda medicamentos. Ele auxilia no acompanhamento e na organização da rotina de cuidados, mas qualquer decisão sobre medicamentos deve ser feita por um profissional de saúde.'
    }
  ];

  alternarPergunta(index: number): void {
    if (this.perguntaAberta === index) {
      this.perguntaAberta = null;
    } else {
      this.perguntaAberta = index;
    }
  }
}
